import { useEffect, useState } from "react";
import {
  MainSidebar,
  PageTitle,
  MainContent,
  SideBarTopActionButton,
  PageTitleWrapper,
} from "../EditorStyles";
import MapMetaDataEditor from "./MapMetaDataEditor";
import { useEditState } from "../EditContext";
import MapEditor from "./MapEditor";
import { ReactComponent as ArrowLeftIcon } from "./../../../images/editor-icons/arrow-left.svg";
import { LayerGroup } from "../../../types";
import SpinnerWrapper from "../BaseComponents/SpinnerWrapper";
import { useRestAuth } from "../../../hooks/useRestAuth";
import { useHistory, useParams } from "react-router-dom";
import { useAppState } from "../../../AppContext";

const SingleMapPage: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [map, setMap] = useState<LayerGroup>();
  const { target, setTarget, mapRepository } = useEditState();
  const restAuth = useRestAuth();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { state } = useAppState();

  useEffect(() => {
    if (id) {
      setTarget(Number(id));
    }
  }, [id, setTarget]);

  useEffect(() => {
    if (target && restAuth) {
      setLoading(true);
      const data = state.map.layerGroups.find((map) => map.id === target);
      setMap(data);
      setLoading(false);
    }
  }, [mapRepository, restAuth, state.map.layerGroups, target]);

  return (
    <SpinnerWrapper loading={loading}>
      <MapEditor layer={map} />
    </SpinnerWrapper>
  );
};

export default SingleMapPage;
